export default __webpack_public_path__ + "static/media/offer2.306a192a.png";